import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // One entry per locale in .l10n.json. German is written here by the UX
    // team; French and Spanish are filled centrally by the release engineer
    // from skp-common/l10n/ and must not be hand-edited.
    resources: {
      de: {
        translation: require("./translations/de.json"),
      },
      fr: {
        translation: require("./translations/fr.json"),
      },
      es: {
        translation: require("./translations/es.json"),
      },
    },
    fallbackLng: { default: ["en"] },
    // An extracted-but-not-yet-translated key is an empty string in the
    // catalog, and i18next treats "" as a valid translation by DEFAULT -- so
    // without this, such a string renders BLANK rather than falling back to
    // English. With this, t() on an empty entry returns the key, which IS the
    // English text.
    //
    // It matters most for French and Spanish: every key they gain from
    // extraction is empty until the next central pass.
    returnEmptyString: false,
    debug: false,
    detection: {
      order: ["querystring", "navigator"],
      lookupQuerystring: "lng",
    },
    interpolation: {
      escapeValue: false,
    },
  });

i18n.languages = ["de", "en", "fr", "es"];

export default i18n;
